import PolicyLayout from "../components/PolicyLayout";

const sections = [
  {
    heading: "Introduction",
    paragraphs: [
      "This Privacy Policy outlines the practices of Finncube Credit Services Pvt. Ltd. regarding the collection, use, disclosure, and protection of personal information of individuals who visit our website, mobile application, or use our services.",
      "FinnCube is dedicated to safeguarding your privacy and ensuring the security of your personal information.",
      "By accessing our website or using our services, you agree to the terms and conditions of this Privacy Policy.",
    ],
  },
  {
    heading: "Information We Collect",
    paragraphs: [
      "We may gather personal information from you when you willingly provide it to us, for example, by filling out forms on our website, communicating with us via email or phone, or applying for our services.",
      "The types of personal information we may collect include:",
    ],
    items: [
      "Contact information such as name, email address, phone number, and postal address.",
      "Photographic identification or proof of address documents.",
      "Information about your financing needs or preferences.",
      "Information about your interactions with our website and services.",
    ],
  },
  {
    heading: "Use of Personal Information",
    paragraphs: [
      "We may use the personal information we collect for the following purposes:",
    ],
    items: [
      "To provide our services and process your financing applications.",
      "To communicate with you regarding inquiries, applications, or account-related matters.",
      "To personalize your experience and improve our website and services.",
      "To send marketing or promotional materials with your consent.",
      "To comply with legal obligations or respond to lawful requests from public authorities.",
    ],
  },
  {
    heading: "Disclosure of Personal Information",
    paragraphs: [
      "We may disclose your personal information to third parties in the following circumstances:",
    ],
    items: [
      "With your consent or at your direction.",
      "To our affiliates, subsidiaries, or related entities for business purposes.",
      "To service providers who assist us in operating our business and providing services.",
      "To comply with legal obligations, enforce our policies, or protect our rights, property, or safety.",
      "In connection with a merger, acquisition, or sale of all or part of our business.",
      "Important: We do not sell, trade, or rent your personal information to third parties for their marketing purposes.",
    ],
  },
  {
    heading: "Data Security",
    paragraphs: [
      "We implement reasonable physical, technical, and administrative security measures to protect the personal information we collect.",
      "However, no method of transmission over the Internet or electronic storage is completely secure. While we strive to protect your personal information, we cannot guarantee absolute security.",
    ],
  },
  {
    heading: "Your Rights",
    paragraphs: [
      "You have certain rights regarding your personal information, subject to applicable law. These rights may include:",
    ],
    items: [
      "Accessing, correcting, or deleting your personal information.",
      "Restricting or objecting to the processing of your personal information.",
      "Withdrawing consent for certain processing activities.",
      "Requesting portability of your personal information.",
      "Filing a complaint with a supervisory authority.",
    ],
  },
  {
    heading: "Cookies and Tracking Technologies",
    paragraphs: [
      "Our website may use cookies and similar tracking technologies to enhance your browsing experience and collect information about how you use our site.",
      "You can manage your cookie preferences through your browser settings.",
    ],
  },
  {
    heading: "Contact Us",
    paragraphs: [
      "If you have any questions, concerns, or requests regarding this Privacy Policy or the processing of your personal information, please contact us:",
      "Email: Care@finncube.com",
      "Phone: +91 9017339057",
    ],
  },
  {
    heading: "Changes to This Privacy Policy",
    paragraphs: [
      "We may update this Privacy Policy from time to time. Any changes will become effective once the revised policy is posted on our website.",
      "We encourage you to review this Privacy Policy periodically to stay informed about how we collect, use, and protect your personal information.",
      "By continuing to use our website or services after changes are posted, you acknowledge and agree to the revised terms.",
    ],
  },
];

function PrivacyPolicy() {
  return (
    <PolicyLayout
      title="Privacy Policy"
      intro="This policy explains how we collect, use, disclose, and protect your personal information when you use our website or services."
      lastUpdated="March 10, 2026"
      sections={sections}
    />
  );
}

export default PrivacyPolicy;
